<template>
  <main class="main cus_mobile_estimate" role="main" v-if="isCompleted">
    <div class="main_con" id="con_fixed" @scroll="handleScroll">
      <div class="e_con">
        <div class="e_step_qa" v-show="isShow">
          <div class="e_question">
            원하는 요금제를<br />선택해주세요.
            <div class="e_question_txt">
              선택된 요금제는 <span>요금유지기간 이후 적용</span>됩니다.
            </div>
          </div>
          <div ref="mobilePaymentComponent">
            <Payment
              :show="isShow"
              @paymentSel="paymentSel"
              :mobilePlanCategory="mobilePlanCategory.content"
              :mobilePlans="mobilePlans.content"
              :deviceId="mobileRequestView.deviceId"
              ref="payment"
            />
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import {
  mapActions as mobileMapActions,
  mapGetters as mobileMapGetters,
} from '@common/store/modules/mobile';
import * as mobileTypes from '@common/store/modules/mobile/types';

import Payment from '@/common/components/mobile/Payment.vue';

export default {
  components: {
    Payment,
  },
  async created() {
    await this.getRequestView();
    // await this.getPaymentCategory();
    // await this.getPaymentList();
    this.isShow = true;
    this.isCompleted = true;
  },
  data() {
    return {
      isCompleted: false,
      isShow: false,
      mobileTelecomId: '',
      planGroup: 'ALL',
      request: {
        buyer: { name: '', value: 0 }, // 구매자
        age: { name: '', value: '' }, // 구매자 나이
        isCurTelecom: { name: '', value: '' }, // 시스템으로 현재 사용중인 통신사가 맞는지 확인 여부
        curTelecom: { name: '', value: '' }, // 현재 사용중인 통신사를 선택
        telecomUse: { name: '', value: '', joinType: '' }, // 통신사를 변경할지 여부 ( 네(번호이동), 아니오(기기변경), 신규가입 )
        selectTelecom: { name: '', value: '' }, // telecomUse (변경할지 여부)에서 (네, 신규가입)을 선택했을때 통신사를 선택
        mvnoTelecom: { name: '', value: '' }, // 알뜰폰 선택시 통신사 선택
        device: {
          id: 0,
          name: '',
          modelName: '',
          color: '',
          noColor: false,
          image: '',
          factoryPrice: 0,
        }, // 디바이스 선택
        dataUse: { name: '', value: '' }, // 데이터 양 사용 확인
        payment: { planId: 0, planName: '', planPrice: 0 }, // 요금제 선택
        location_1: { areaId: 0, areaName: '', areaFullName: '' }, // 견적받을 동네 1
        location_2: { areaId: 0, areaName: '', areaFullName: '' }, // 견적받을 동네 2
      },
    };
  },
  async mounted() {
    this.$nextTick(function() {
      // 전체 화면내용이 렌더링된 후에 아래의 코드가 실행됩니다.
    });
  },
  watch: {
    isCompleted() {
      if (this.isCompleted) {
        this.getPaymentCategory();
      }
    },
  },
  computed: {
    ...mobileMapGetters({
      mobileRequestView: mobileTypes.MOBILE_REQUEST_VIEW,
      mobileTelecoms: mobileTypes.MOBILE_TELECOMS,
      mobileCategory: mobileTypes.MOBILE_CATEGORY,
      mobilePlanCategory: mobileTypes.MOBILE_PLAN_CATEGORY,
      mobilePlans: mobileTypes.MOBILE_PLANS,
      mobilePlanDetail: mobileTypes.MOBILE_PLAN_DETAIL,
    }),
  },
  methods: {
    ...mobileMapActions([
      mobileTypes.SELECT_MOBILE_TELECOMS,
      mobileTypes.SELECT_MOBILE_CATEGORY,
      mobileTypes.SELECT_MOBILE_PLAN_CATEGORY,
      mobileTypes.SELECT_MOBILE_PLANS,
      mobileTypes.SELECT_MOBILE_PLAN_DETAIL,
      mobileTypes.INSERT_MOBILE_REQUESTS,
      mobileTypes.SELECT_MOBILE_REQUEST_VIEW,
      mobileTypes.UPDATE_MOBILE_PLAN,
    ]),
    async getRequestView() {
      let params = {
        callPart: 'CUSTOMER',
        id: parseInt(this.$route.params.requestId, 10),
      };
      await this[mobileTypes.SELECT_MOBILE_REQUEST_VIEW](params);

      console.log(params);

      console.log('mobileRequestView');
      console.log(this.mobileRequestView);
    },
    async getPaymentCategory() {
      let params = {
        telecomId: this.mobileRequestView.telecomId,
        planGroup: this.planGroup,
        deviceId: this.mobileRequestView.deviceId,
      };
      await this[mobileTypes.SELECT_MOBILE_PLAN_CATEGORY](params);

      console.log('this.mobilePlanCategory');
      console.log(params);
      console.log(this.mobilePlanCategory);

      if (this.planGroup != 'ALL') {
        var mobilePlanCategory = this.mobilePlanCategory.content.categories.find(
          v => v.selectYn === 'Y',
        );

        this.$refs.payment.categoryName = mobilePlanCategory.categoryName;
        this.$refs.payment.categoryId = mobilePlanCategory.categoryId;
      } else {
        this.$refs.payment.categoryName = '';
        this.$refs.payment.categoryId = 0;
      }

      if (this.mobilePlanCategory.content.networks != null) {
        var mobilePlanNetwork = this.mobilePlanCategory.content.networks.find(
          v => v.selectYn === 'Y',
        );
        this.$refs.payment.networkType = mobilePlanNetwork.networkType;
      }

      console.log(mobilePlanCategory);

      console.log(mobilePlanNetwork);
      console.log('mobilePlanCategory');
      console.log(this.mobilePlanCategory);

      await this.getPaymentList();
    },
    async getPaymentList() {
      let params = {
        callPart: 'CUSTOMER',
        telecomId: this.mobileRequestView.telecomId,
        categoryId: this.$refs.payment.categoryId,
        orderType: this.$refs.payment.paymentSortVal,
        deviceId: this.mobileRequestView.deviceId,
        networkType: this.$refs.payment.networkType,
        keyword: this.$refs.payment.keyword,
      };
      await this[mobileTypes.SELECT_MOBILE_PLANS](params);

      console.log(params);

      console.log('mobilePlans');
      console.log(this.mobilePlans);
    },
    paymentSel() {
      // alert(4);
      // this.request.payment.planId = this.$refs.payment.planId;
      // this.request.payment.planName = this.$refs.payment.planName;
      // this.request.payment.planPrice = this.$refs.payment.planPrice;

      console.log(this.$refs.payment.planId);
      console.log(this.$refs.payment.planName);
      console.log(this.$refs.payment.planPrice);
      console.log(this.$route.params.requestId);
      console.log(this.$route.params.index);
      console.log(this.$route.params.payType);
      console.log(this.$route.params.orderType);

      let params = {
        id: parseInt(this.$route.params.requestId, 10),
        planId: this.$refs.payment.planId,
        planName: this.$refs.payment.planName,
        planPrice: this.$refs.payment.planPrice,
      };
      this[mobileTypes.UPDATE_MOBILE_PLAN](params).then(() => {
        this.$router.go(-1);
      });
    },
    handleScroll() {
      const target = this.$refs.mobilePaymentComponent;
      const targetTop = target.getBoundingClientRect().top;
      // console.log('targetTop = ' + targetTop);

      if (targetTop <= 53) {
        this.$refs.payment.isTabFixed = true;
      } else {
        this.$refs.payment.isTabFixed = false;
      }
    },
  },
};
</script>
